// Email form submission handler
export function initEmailForm() {
    const forms = document.querySelectorAll<HTMLFormElement>('.email-signup-form');

    forms.forEach((form) => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]');
            const emailInput = form.querySelector<HTMLInputElement>('input[type="email"]');
            const messageDiv = form.querySelector<HTMLElement>('.form-message');
            const nonce = form.getAttribute('data-nonce');

            if (!submitButton || !emailInput || !messageDiv || !nonce) return;

            const email = emailInput.value.trim();

            if (!email) {
                showMessage(messageDiv, 'Please enter your email address.', 'error');
                return;
            }

            // Disable submit button
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';

            try {
                const formData = new FormData();
                formData.append('action', 'submit_email_form');
                formData.append('email', email);
                formData.append('nonce', nonce);

                const response = await fetch('/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    body: formData,
                });

                const result = await response.json();

                if (result.success) {
                    showMessage(messageDiv, result.data.message, 'success');
                    emailInput.value = ''; // Clear the input

                    // Optional: Add link to survey
                    const surveyLink = document.createElement('p');
                    surveyLink.className = 'mt-4';
                    surveyLink.innerHTML = '<strong>>>> <a href="https://digitalstorytellingguide.com/build-something-meaningful-with-us/" class="underline">Take the 9-question survey</a></strong> (it only takes a minute, and helps us support you better)';
                    messageDiv.appendChild(surveyLink);
                } else {
                    showMessage(messageDiv, result.data.message || 'An error occurred. Please try again.', 'error');
                }
            } catch (error) {
                console.error('Form submission error:', error);
                showMessage(messageDiv, 'An error occurred. Please try again.', 'error');
            } finally {
                submitButton.disabled = false;
                submitButton.textContent = 'Submit';
            }
        });
    });
}

function showMessage(container: HTMLElement, message: string, type: 'success' | 'error') {
    container.innerHTML = message;
    container.classList.remove('hidden');

    if (type === 'success') {
        container.classList.add('text-green');
        container.classList.remove('text-red-600');
    } else {
        container.classList.add('text-red-600');
        container.classList.remove('text-green');
    }
}
